import React from "react";
// import { SmoothVideoPlayer } from "./components/SmoothVideoPlayer";
// import { StreamVideoPlayer } from "./components/StreamVideoPlayer";
// import Fmp4InternetPlayer from "./components/Fmp4InternetPlayer";
// import DashMsePlayer from "./components/DashMsePlayer";
// import VideoStreamer from "./components/VideoStreamer";
// import DashMsePlayer2 from "./components/DashMsePlayer2";
import { HLSPlaylistPlayer } from "./components/HLSPlaylistPlayer";
import { StreamingPlayer } from "./components/StreamingPlayer";
import { StreamingPlayer3 } from "./components/StreamingPlayer3";

const url1 =
  "https://fastapi.dev.torsunov.pro/download_rus?file_name=df2b873f2a894e82a116283bf1b8c893/files_to_send/1.mp4";
const url2 =
  "https://fastapi.dev.torsunov.pro/download_rus?file_name=df2b873f2a894e82a116283bf1b8c893/files_to_send/2.mp4";
const url3 =
  "https://fastapi.dev.torsunov.pro/download_rus?file_name=df2b873f2a894e82a116283bf1b8c893/files_to_send/3.mp4";
const url4 =
  "https://fastapi.dev.torsunov.pro/download_rus?file_name=df2b873f2a894e82a116283bf1b8c893/files_to_send/4.mp4";
const urls = [url1, url2, url3, url4];
export const Stream = () => {
  let index = 0;
  const fetchNextUrl = (index: number) => {
    console.log("fetchNextUrl", index);
    return urls[index];
  };
  return (
    <div>
      {/*<SmoothVideoPlayer initialUrl={url1} fetchNextUrl={fetchNextUrl} />*/}
      {/*<StreamVideoPlayer />*/}
      {/*<Fmp4InternetPlayer />*/}
      {/*<DashMsePlayer />*/}
      {/*<DashMsePlayer2 />*/}
      {/*<VideoStreamer />*/}
      <HLSPlaylistPlayer />
      {/*<StreamingPlayer />*/}
    </div>
  );
};

export const Stream2 = () => {
  let index = 0;
  const fetchNextUrl = (index: number) => {
    console.log("fetchNextUrl", index);
    return urls[index];
  };
  return (
    <div>
      {/*<SmoothVideoPlayer initialUrl={url1} fetchNextUrl={fetchNextUrl} />*/}
      {/*<StreamVideoPlayer />*/}
      {/*<Fmp4InternetPlayer />*/}
      {/*<DashMsePlayer />*/}
      {/*<DashMsePlayer2 />*/}
      {/*<VideoStreamer />*/}
      {/*<HLSPlaylistPlayer />*/}
      <StreamingPlayer />
      {/*<StreamingPlayer3 />*/}
    </div>
  );
};
